import Route from 'cio/routes/base';
import TransactionalMessageModel from 'cio/models/transactional-message';

export default class TransactionalMessage extends Route {
  redirect(model: TransactionalMessageModel) {
    if (model.isActive || model.isDefault) {
      this.router.transitionTo('transactional.message.overview');
    } else {
      this.router.transitionTo('transactional.message.setup');
    }
  }
}
